import { dbAdapter } from './databaseAdapter';

export const customerService = {
  // GET ALL
  getAll: async () => {
    return dbAdapter.get('customers');
  },
  
  // GET BY ID
  getById: async (id) => {
    return dbAdapter.getById('customers', id);
  },
  
  // GET ACTIVE
  getActive: async () => {
    const customers = await dbAdapter.get('customers');
    return customers.filter(c => c.status === 'active');
  },
  
  // GET INACTIVE
  getInactive: async () => {
    const customers = await dbAdapter.get('customers');
    return customers.filter(c => c.status === 'inactive');
  },
  
  // CREATE
  create: async (data) => {
    const newCustomer = {
      id: `CUST-${Date.now()}`,
      ...data,
      status: data.status || 'active',
      totalOrders: 0,
      lastService: null,
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString()
    };
    return dbAdapter.create('customers', newCustomer);
  },
  
  // UPDATE
  update: async (id, data) => {
    return dbAdapter.update('customers', id, data);
  },
  
  // DELETE
  delete: async (id) => {
    // Check if customer has work orders
    const workOrders = await dbAdapter.get('work_orders');
	const hasOrders = workOrders.some(wo => wo.customerId === id);
    if (hasOrders) {
      throw new Error('Customer has existing work orders. Delete work orders first or reassign them.');
    }
    return dbAdapter.delete('customers', id);
  },
  
  // UPDATE STATS
  updateStats: async (customerId) => {
    const workOrders = await dbAdapter.get('work_orders');
    const customerOrders = workOrders.filter(wo => wo.customerId === customerId);
    const completed = customerOrders.filter(wo => wo.status === 'completed');
    
    const totalOrders = customerOrders.length;
    const lastService = completed.length > 0 
  ? completed.sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt))[0]?.updatedAt
  : null;
    
    return dbAdapter.update('customers', customerId, { 
      totalOrders, 
      lastService 
    });
  }
};
